var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54795 0.221469V0.669809C5.54795 0.794085 5.4453 0.896738 5.32102 0.896738H0.896661V8.09781H8.09773L8.0978 4.36492C8.0978 4.24064 8.20045 4.13799 8.32473 4.13799H8.77307C8.89735 4.13799 9 4.24064 9 4.36492L8.99992 8.55159C8.99992 8.78928 8.81626 8.98372 8.58398 8.99993H0.44834C0.210645 8.99993 0.0162065 8.81626 0 8.58398V0.44834C0 0.210645 0.183664 0.0162065 0.415946 0H5.3211C5.44538 0 5.54803 0.0972214 5.54803 0.22143L5.54795 0.221469Z",
    fill: "#143232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61399 4.92144L9.83307 0.702364C9.91408 0.621347 9.98975 0.621347 10.0708 0.702364L10.4705 1.1021C10.5515 1.18312 10.5515 1.25879 10.4705 1.3398L6.25142 5.55888C6.1704 5.63989 6.09474 5.63989 6.01373 5.55888L5.61399 5.15914C5.53297 5.07812 5.53297 4.9971 5.61399 4.92144Z",
    fill: "#143232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownEdit);
export default __webpack_public_path__ + "static/media/dropdown-edit.3f82b569b601b7f6fa12f2e53eab02ec.svg";
export { ForwardRef as ReactComponent };